import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[repeatElement]',
    standalone: true
})
export class RepeatElementDirective {
    constructor(
        private readonly _templateRef: TemplateRef<unknown>,
        private readonly _viewContainer: ViewContainerRef
    ) {}

    @Input() set repeatElement(t: number) {
        this._viewContainer.clear();
        for (let i = 0; i < t; i++) {
            this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }
}
